// extracted by mini-css-extract-plugin
module.exports = {"search":"warning-record_search_3Arsa","itemWrap":"warning-record_itemWrap_1J8uf","item":"warning-record_item_M88jO"};